import { INotification } from 'interfaces/i-notification';
import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { create } from 'zustand';

type InboxState = {
  inbox: INotification[];
  dialog: Nullable<number>;
};

type InboxActions = {
  setDialog: (v: Nullable<number>) => void;
  add: (value: INotification) => void;
  removeById: (id: string | undefined) => void;
  removeAll: () => void;
};

type InboxStore = InboxState & InboxActions;

const useInboxStore = create<InboxStore>((set, get) => ({
  inbox: [],
  dialog: null,

  setDialog: (v) => set({ dialog: v }),
  add: (v) => {
    const { inbox } = get();
    set({ inbox: [...inbox, v] });
  },
  removeById: (id) => {
    const { inbox } = get();
    set({ inbox: inbox.filter((m) => m.id !== id) });
  },
  removeAll: () => set({ inbox: [] }),
}));

export default useInboxStore;
